<app-breadcrumb></app-breadcrumb>
<router-outlet></router-outlet>
<footer class="bg-dark p-2 w-100">
    <div class="col-md-12 text-white bg-dark p-2">
      <small>Copyright &copy; 2022 NSFAS Online Application</small>
    </div>
  </footer>